import styled from 'styled-components';

import { ContainerProps } from './interface';

export const Container = styled.td<ContainerProps>`
  padding: 1rem;
  font-size: 0.8rem;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0);
  font-weight: 400;
  min-height: 50px;
  width: ${props => (props.width ? `${props.width}px !important` : 'auto')};
  overflow: hidden;
  vertical-align:top;

  color: ${({ theme, color }) => (color ? color : theme.colors.GRID_ITEM_TEXT)};

  @media (max-width: 1600px) {
    font-size: 0.7rem;
    padding: 0.5rem;
  }


  &:first-child {
    border: none;
  }

  strong {
    color: ${({ theme, color }) =>
      color ? color : theme.colors.GRID_ITEM_TEXT_BOLD};
    font-weight: 700;
  }


  .sequence {
    background: #08d781;
    width: 40px;
    height: 40px;
    margin: -5px 0;
    border-radius: 20px;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
